import {easepick, LockPlugin, RangePlugin} from '@easepick/bundle'

export default class BookingModal {
	static dateStart = ''
	static dateEnd = ''
	static adultsQty = 1
	static childrenQty = 0
	static accommodationType = $('[data-id="wpiris-engine-booking-item"]').attr('action')
	static actionUrl =
		`${BookingModal.accommodationType}recherche/marketplace/${BookingModal.dateStart}/${BookingModal.dateEnd}/${BookingModal.adultsQty}/${BookingModal.childrenQty}`

	constructor() {
		BookingModal.openClose()
		BookingModal.engineBooking()
		BookingModal.engineDate()
	}

	static openClose() {
		const bookingBtn = $('[data-id="booking-btn"]')
		const engineBooking = $('[data-id="engine-booking"]')
		const closeBtn = $('[data-id="close-engine-booking"]')

		bookingBtn.on('click', () => {
			engineBooking.addClass('show').removeClass('hide')
		})

		closeBtn.on('click', () => {
			engineBooking.addClass('hide').removeClass('show')
		})
	}

	static engineBooking() {
		$('[data-id="engine-list-tabs"] li').click(function () {
			const formClass = $(this).attr('class').split(' ')[0] // Get class of menu element without 'active' class
			$('[data-id="engine-list-tabs"] li').removeClass('active')
			$(this).addClass('active')

			$.each($('.engine-booking__body__engine-list form'), function () {
				if ($(this).hasClass(formClass)) {
					$(this).fadeIn()
				} else {
					$(this).fadeOut()
				}
			})

			return false
		})

		if ($('.engine-booking__body').length > 0) {
			const form = $('[data-id="wpiris-engine-booking-item"]')
			form.each(function () {
				const thisForm = $(this)
				thisForm.find('[data-id="wpiris-engine-booking-select"]').on('change', () => {
					BookingModal.accommodationType = thisForm
						.find('[data-id="wpiris-engine-booking-select"] option:selected')
						.attr('data-action')
					BookingModal.actionUrl = `${BookingModal.accommodationType}recherche/marketplace/${BookingModal.dateStart}/${BookingModal.dateEnd}/${BookingModal.adultsQty}/${BookingModal.childrenQty}`
					thisForm.attr('action', BookingModal.actionUrl)
				})
			})
		}

		if ($('.engine-booking__body').length > 0) {
			const form = $('[data-id="wpiris-engine-booking-item"]')
			form.each(function () {
				const thisForm = $(this)
				thisForm.find('[data-wpet-marketplace-field="person"]').on('change', () => {
					const adultsQty = thisForm
						.find('[data-wpet-marketplace-field="person"] option:selected')
						.val()
					BookingModal.adultsQty = adultsQty === 'off' ? 0 : adultsQty
					BookingModal.actionUrl = `${BookingModal.accommodationType}recherche/marketplace/${BookingModal.dateStart}/${BookingModal.dateEnd}/${BookingModal.adultsQty}/${BookingModal.childrenQty}`
					thisForm.attr('action', BookingModal.actionUrl)
				})
			})
		}

		if ($('.engine-booking__body').length > 0) {
			const form = $('[data-id="wpiris-engine-booking-item"]')
			form.each(function () {
				const thisForm = $(this)
				thisForm.find('[data-wpet-marketplace-field="children"]').on('change', () => {
					const childrenQty = thisForm
						.find('[data-wpet-marketplace-field="children"] option:selected')
						.val()
					BookingModal.childrenQty = childrenQty === 'off' ? 0 : childrenQty
					BookingModal.actionUrl = `${BookingModal.accommodationType}recherche/marketplace/${BookingModal.dateStart}/${BookingModal.dateEnd}/${BookingModal.adultsQty}/${BookingModal.childrenQty}`
					thisForm.attr('action', BookingModal.actionUrl)
				})
			})
		}
	}

	static engineDate() {
		if ($('#engine-booking-start-date--un-hebergement').length > 0) {
			const dateFormat = 'DD MMM YYYY'

			new easepick.create({
				element: document.getElementById('engine-booking-start-date--un-hebergement'),
				lang: 'fr-FR',
				format: dateFormat,
				css: [
					'https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css',
					`${IRISCollectionCustomer.customerEasepickStyleUrl}`,
				],
				plugins: [RangePlugin, LockPlugin],
				RangePlugin: {
					elementEnd: document.getElementById('engine-booking-end-date--un-hebergement'),
					tooltip: true,
				},
				LockPlugin: {
					minDate: new Date(),
				},
				setup(picker) {
					picker.on('select', (e) => {
						const startDate = e.detail.start.format('YYYY-MM-DD')
						const endDate = e.detail.end.format('YYYY-MM-DD')
						const value = {
							start: startDate,
							end: endDate,
						}
						const valueDateStart = $('#valueDateStart')
						const valueDateEnd = $('#valueDateEnd')
						valueDateStart.attr('value', value.start)
						valueDateEnd.attr('value', value.end)
						BookingModal.dateStart = value.start
						BookingModal.dateEnd = value.end
						BookingModal.actionUrl = `${BookingModal.accommodationType}recherche/marketplace/${BookingModal.dateStart}/${BookingModal.dateEnd}/${BookingModal.adultsQty}/${BookingModal.childrenQty}`
						this.element.parentNode.parentNode.parentNode.parentNode.parentNode.setAttribute(
							'action',
							BookingModal.actionUrl,
						)
					})
				},
			})
		}
		if ($('#engine-booking-start-date--un-sejour').length > 0) {
			const dateFormat = 'DD MMM YYYY'

			new easepick.create({
				element: document.getElementById('marketplace_search_startdate'),
				lang: 'fr-FR',
				format: dateFormat,
				css: [
					'https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css',
					`${IRISCollectionCustomer.customerEasepickStyleUrl}`,
				],
				plugins: [RangePlugin, LockPlugin],
				RangePlugin: {
					elementEnd: document.getElementById('marketplace_search_enddate'),
					tooltip: true,
				},
				LockPlugin: {
					minDate: new Date(),
				},
				setup(picker) {
					picker.on('select', (e) => {
						const startDate = e.detail.start.format('YYYY-MM-DD')
						const endDate = e.detail.end.format('YYYY-MM-DD')
						const value = {
							start: startDate,
							end: endDate,
						}
						const valueDateStart = $('#valueDateStart')
						const valueDateEnd = $('#valueDateEnd')
						valueDateStart.attr('value', value.start)
						valueDateEnd.attr('value', value.end)
					})
				},
			})
		}
		if ($('#engine-booking-start-date--une-activite').length > 0) {
			const $bookingEngineModal = $('.js-customer-booking-engine-modal')
			const dateFormat = 'DD MMM YYYY'

			new easepick.create({
				element: document.getElementById('marketplace_search_startdate'),
				lang: 'fr-FR',
				format: dateFormat,
				css: [
					'https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css',
					`${IRISCollectionCustomer.customerEasepickStyleUrl}`,
				],
				plugins: [RangePlugin, LockPlugin],
				RangePlugin: {
					elementEnd: document.getElementById('marketplace_search_enddate'),
					tooltip: true,
				},
				LockPlugin: {
					minDate: new Date(),
				},
				setup(picker) {
					picker.on('select', (e) => {
						const startDate = e.detail.start.format('YYYY-MM-DD')
						const endDate = e.detail.end.format('YYYY-MM-DD')
						const value = {
							start: startDate,
							end: endDate,
						}
						const valueDateStart = $('#valueDateStart')
						const valueDateEnd = $('#valueDateEnd')
						valueDateStart.attr('value', value.start)
						valueDateEnd.attr('value', value.end)
					})
				},
			})
		}
		if ($('#engine-booking-start-date--une-visite').length > 0) {
			const $bookingEngineModal = $('.js-customer-booking-engine-modal')
			const dateFormat = 'DD MMM YYYY'

			new easepick.create({
				element: document.getElementById('marketplace_search_startdate'),
				lang: 'fr-FR',
				format: dateFormat,
				css: [
					'https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css',
					`${IRISCollectionCustomer.customerEasepickStyleUrl}`,
				],
				plugins: [RangePlugin, LockPlugin],
				RangePlugin: {
					elementEnd: document.getElementById('marketplace_search_enddate'),
					tooltip: true,
				},
				LockPlugin: {
					minDate: new Date(),
				},
				setup(picker) {
					picker.on('select', (e) => {
						const startDate = e.detail.start.format('YYYY-MM-DD')
						const endDate = e.detail.end.format('YYYY-MM-DD')
						const value = {
							start: startDate,
							end: endDate,
						}
						const valueDateStart = $('#valueDateStart')
						const valueDateEnd = $('#valueDateEnd')
						valueDateStart.attr('value', value.start)
						valueDateEnd.attr('value', value.end)
					})
				},
			})
		}
		if ($('#engine-booking-start-date--billetterie').length > 0) {
			const $bookingEngineModal = $('.js-customer-booking-engine-modal')
			const dateFormat = 'DD MMM YYYY'

			new easepick.create({
				element: document.getElementById('marketplace_search_startdate'),
				lang: 'fr-FR',
				format: dateFormat,
				css: [
					'https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css',
					`${IRISCollectionCustomer.customerEasepickStyleUrl}`,
				],
				plugins: [RangePlugin, LockPlugin],
				RangePlugin: {
					elementEnd: document.getElementById('marketplace_search_enddate'),
					tooltip: true,
				},
				LockPlugin: {
					minDate: new Date(),
				},
				setup(picker) {
					picker.on('select', (e) => {
						const startDate = e.detail.start.format('YYYY-MM-DD')
						const endDate = e.detail.end.format('YYYY-MM-DD')
						const value = {
							start: startDate,
							end: endDate,
						}
						const valueDateStart = $('#valueDateStart')
						const valueDateEnd = $('#valueDateEnd')
						valueDateStart.attr('value', value.start)
						valueDateEnd.attr('value', value.end)
					})
				},
			})
		}
	}
}
